import { recurringScheduleApi } from "./recurringSchedule";

export const {
  useGetRecurringSchedulesQuery,
  useDeleteRecurringScheduleMutation,
  usePostRecurringScheduleMutation
} = recurringScheduleApi;
